/* eslint-disable */
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import ReactNotifications from 'react-notifications-component';

import accountRoutes from "routes/account.jsx";

//core components
import Footer from "../components/Footer/Footer";
// import Header from "../components/Header/Header";
import AccountHeader from "../components/Header/AccountHeaderLinks";

const switchRoutes = (
  // switching routes of from account routes
  <Switch>
    {accountRoutes.map((prop, key) => {
      if (prop.redirect)
        return <Redirect from={prop.path} to={prop.to} key={key} />;
      return <Route path={prop.path} component={prop.component} key={key} />;
    })}
  </Switch>
);

class Account extends React.Component {
  constructor(props) {
    super(props);
  }

  handleDrawerToggle = () => {
    this.setState({ mobileOpen: !this.state.mobileOpen });
  };

  render() {
    const { classes, ...rest } = this.props;
    const backgroundImage = "https://skyframework.pccwglobal.com/img/csp-slide-6-md.jpg"
    return (
      <div className="wrapper">
        <div className="background-cover-wrap">
          <div className="background-cover appear" style={{ backgroundImage: "url(" + backgroundImage + ")" }}>
          </div>
        </div>
        <div className="header">
          <div className="nav-bar">
            <h1 className="logo">
              <a href="/visitor">
                <img src="https://skyframework.pccwglobal.com/img/pccwglobal.svg" />
              </a>
            </h1>
          </div>
        </div>
        <div className="content">
          <div className="content-item d-flex align-items-center justify-content-center">
            <div className="content-overflown">
              <div className="container-xs">
                {switchRoutes}
              </div>
            </div>
          </div>
        </div>
        <ReactNotifications />
        <Footer />
      </div>
    );
  }
}

export default (Account);
